import { UserRole, PermissionCheck } from './types';

// 根据用户角色获取权限
export function getPermissions(role: UserRole | null): PermissionCheck {
  // 默认情况下，如果没有用户认证，允许所有操作（向后兼容）
  if (!role) {
    return {
      canView: true,
      canEdit: true,
      canDelete: true,
      canCreate: true,
    };
  }

  switch (role) {
    case 'viewer':
      return {
        canView: true,
        canEdit: false,
        canDelete: false,
        canCreate: false,
      };
    case 'editor':
      return {
        canView: true,
        canEdit: true,
        canDelete: false,
        canCreate: true,
      };
    case 'supervisor':
      return {
        canView: true,  // 可以查看所有项目
        canEdit: true,  // 可以编辑所有项目
        canDelete: false,
        canCreate: true,
      };
    case 'admin':
      return {
        canView: true,
        canEdit: true,
        canDelete: true,
        canCreate: true,
      };
    default:
      return {
        canView: true,
        canEdit: false,
        canDelete: false,
        canCreate: false,
      };
  }
}

// 检查用户是否有特定权限
export function hasPermission(
  role: UserRole | null,
  permission: 'view' | 'edit' | 'delete' | 'create'
): boolean {
  const permissions = getPermissions(role);
  switch (permission) {
    case 'view':
      return permissions.canView;
    case 'edit':
      return permissions.canEdit;
    case 'delete':
      return permissions.canDelete;
    case 'create':
      return permissions.canCreate;
    default:
      return false;
  }
}

